import styled from 'styled-components';

export const MultiLineChartRoot = styled.div`
  position: relative;
  overflow: visible;
`;

export const MultiLineChartContainer = styled.div`
  overflow: visible;
`;

export const Plot = styled.svg`
  position: relative;
  width: 100%;
  height: 340px;
  overflow: visible;
`;

export const CanvasOverlay = styled.canvas<{
  $marginTop: number;
  $marginLeft: number;
}>`
  position: absolute;
  top: ${({ $marginTop }) => $marginTop}px;
  left: ${({ $marginLeft }) => $marginLeft}px;
  pointer-events: none;
`;

export const TooltipLine = styled.line`
  stroke: var(--border-default);
  stroke-dasharray: 4 4;
`;

export const VerticalLine = styled.line`
  stroke: var(--border-default);
  stroke-width: 2px;
`;
